import type { DataNode } from 'antd/es/tree';
import { useStore } from '../../../store/reducers';
import { draggableDataNode } from './nodes';
import type { FilterNodeProps } from './prepareFilterSubTreeComponentMapping';

export const FilterNode = (props: FilterNodeProps): DataNode => {
  const { key, title, filterLabels, filters } = props;
  const filterCounts = useStore((s) => s.trackers.filterCounts);
  const counts = filterCounts.get(key);

  const nodes = Object.values(filters).map(
    (filter): DataNode =>
      draggableDataNode(
        filterLabels?.[filter] ?? filter,
        `${key}/${filter.toString()}`,
        counts?.get(filter.toString()),
      ),
  );

  return {
    key,
    title,
    children: nodes,
    disableCheckbox: true,
  };
};
